export const firstUseCalibrationMessages = {
  'zh-CN': {
    intro: '首次连接，正在自动识别游戏界面。请保持角色状态栏可见；打开背包可一并识别金币。',
    skip: '跳过，使用默认设置',
    fallback: '未定位且没有已有校准的项目保留默认设置，并继续在后台定位；定位完成前暂不显示读数。',
    storageFailed: '首次识别状态未能保存，本次不会重复弹出；下次打开可能再次自动识别。',
  },
  en: {
    intro: 'Finding your game layout on the first connection. Keep the status bar visible; open the inventory to also locate Mesos.',
    skip: 'Skip, use defaults',
    fallback: 'Items without a located or previously calibrated area keep their default settings while background detection continues. Readings appear after their areas are located.',
    storageFailed: 'Could not save the first-use recognition status. It will not repeat this visit, but may run again next time.',
  },
}
